export const LOGIN_FIELD = 'username'
export const PASSWORD_FIELD = 'password'
